import React from "react";
import { useQuery } from "@apollo/client";
import RubieApolloClient from "../services/RubieApolloClient";

const WithQuery = (WrappedComponent, query, variables, moreProps) => {
  return function inner(props) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { loading, error, data, refetch } = useQuery(query, {
      client: RubieApolloClient,
      variables,
    });

    return (
      <WrappedComponent
        data={data}
        loading={loading}
        error={error}
        refetch={refetch}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...moreProps}
      />
    );
  };
};

export default WithQuery;
